export const LOGIN = "login";
export const LOGIN_V2 = "login_v2";
export const SIGNUP = "signup";
export const SIGNUP_V2 = "signup_v2";
export const RESET_PASSWORD = "forgot";
export const RESET_PASSWORD_OK = "password_sent";
export const POP = "pop";
export const ADDUSER = "adduser";
export const DOT_VALIDATE = "dot_validate";
export const EMAIL_VALIDATE = "email_validate";
export const PHONE_VALIDATE = "phone_validate";
export const PHONE_SUCCESS = "phone_success";
export const RATEUPDATE = "rate_update";
export const CREATE_BID = "create_bid";
export const CREATE_BID_RESULT = "create_bid_result";
export const PROFILE_VERIFY = "profile_verify";
export const BOOKNOW = "booknow";
export const BOOKNOWLOADSMART = 'booknowloadsmart';
export const BOOKCANCEL = "cancel";
export const BOOKDELETE = "delete";
export const REFRESH_HINTS = "refresh_hints";
export const POSTTRUCK_RATE = "posttruck_rate";
export const BOOKRC_VIEW = "bookrc_view";
export const DOT_CONFIRM = "dot_confirm"
export const NOT_IN_NETWORK = 'not_in_network';
export const NOT_IN_NETWORK_BID = 'not_in_network_bid';
export const VERIFICATION_PENDING = 'verification_pending';
export const PENDING = 'PENDING';
export const DOT_UNEDITABLE = 'dot_uneditable'
export const LOADSMART_ONBOARD = "loadsmart_onboard"
export const NEED_L1 = 'need_l1';
export const LOAD_DISAPPER = 'load_disapper';
export const MEMBERSHIP_PLANS = 'membership_plans'
export const BID_PARADE = 'bid_parade'
export const SET_ALERT_ONCE = 'set_alert_once'
export const FUEL_SURCHANGE = 'fuel_surcharge'



// WEBPACK FOOTER //
// ./src/modules/modal/modes.js